import {
  Card,
  Typography,
  CardContent,
  Grid,
  Rating,
  Box,
  Breadcrumbs,
  Button,
} from "@mui/material";
import { Link } from "react-router-dom";
import styles from "../../styles/common/sideCard.module.css";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LinkIcon from "@mui/icons-material/Link";
import { toShortNumber } from "../../lib/util";

type ProposalInfoCardProps = {
  proposalTitle: string;
  rating: number;
  funded_status: boolean;
  challenge_name: string;
  fund_name: string;
  user_name: string;
  solution: string;
  fund_id: number;
  challenge_id: number;
  url: string;
  amount_requested: number;
  no_assessments: number;
};

const ProposalInfoCard = (props: ProposalInfoCardProps) => {
  return (
    <Card
      className={
        props.funded_status ? styles.cardLeftAlgnFunded : styles.cardLeftAlgn
      }
      elevation={4}
      sx={{ borderRadius: "10px" }}
    >
      <CardContent className={styles.cardContent}>
        <Grid container spacing={1} direction="column">
          <Grid item>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />}>
              [
              <Link to={"/fund/" + props.fund_id + "/challenges"}>
                <Typography variant="body1" color="text.primary">
                  {props.fund_name}
                </Typography>
              </Link>
              ,
              <Link to={"/challenge/" + props.challenge_id}>
                <Typography variant="body1" color="text.primary">
                  {props.challenge_name}
                </Typography>
              </Link>
              ]
            </Breadcrumbs>
          </Grid>
          <Grid item>
            <Typography gutterBottom variant="h5">
              {props.proposalTitle}
            </Typography>
          </Grid>
          <Grid item>
            <Box className={styles.ratingBox}>
              <Rating
                name="size-medium"
                defaultValue={props.rating}
                readOnly
                precision={0.1}
              />
              <Box className={styles.ratingNumberBox}>
                {props.rating.toFixed(1) + " (" + props.no_assessments + ")"}
              </Box>
            </Box>
          </Grid>

          <Grid item>
            <Typography gutterBottom variant="body1">
              Amount Requested: {"$" + toShortNumber(props.amount_requested)}
            </Typography>
          </Grid>

          <Grid item>
            <Typography gutterBottom variant="body2">
              {"Solution: " + props.solution}
            </Typography>
          </Grid>
          <Grid item>
            <Button target="_blank" href={props.url} startIcon={<LinkIcon />}>
              View proposal on ideascale
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ProposalInfoCard;
